import { render } from "./ServiceManagement.vue?vue&type=template&id=26d8b326&scoped=true"
import script from "./ServiceManagement.vue?vue&type=script&lang=js"
export * from "./ServiceManagement.vue?vue&type=script&lang=js"

import "./ServiceManagement.vue?vue&type=style&index=0&id=26d8b326&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-26d8b326"

export default script